<template>
  <!-- 分组选择成员 -->
  <div class="my-select">
    <div class="select-div-top">
      <div class="aifv-bg"></div>
      <form action="/" class="logo-container">
        <div class="head">
          <van-search v-model="searchValue" right-icon="" shape="round" placeholder="搜索内容" @search="onCourseSearchEnter"
            :clearable="true" clear-trigger="always" @clear="clearSearchValue">
            <template #left-icon>
              <van-icon name="search" />
            </template>
          </van-search>
        </div>
      </form>
    </div>
    <ul class="list" v-if="list.length > 0">
      <li v-for="(item, index) in list" :key="index" class="list-item" @click="changeList(item, index)">
        <img src="@/assets/images/grade/select.png" v-if="item.checkedPush" class="icon-check" alt="" />
        <img src="@/assets/images/teacher-task/un-select.png" v-else class="icon-check" alt="" />
        <img src="../../../assets/images/grade/icon-student.png" class="avatar" />
        <div class="info">
          <div class="name mb8">
            {{ item.realName }}
          </div>
          <div class="currentLevel">
            <img src="../../../assets/images/grade/icon-current.png" alt="" class="icon-current" />
            <p class="level-title">{{ item.currentStageCj }}</p>
          </div>
          <div class="hospital">{{ item.hospitalName }}</div>
        </div>
      </li>
    </ul>
    <div class="empty-block" v-else>
      <img src="@/assets/images/zone/img18.png" class="empty-img" alt="" />
      <div class="empty-txt">暂无内容</div>
    </div>
    <button class="confirm-button" @click="handleOk" v-if="list.length">
      确定
    </button>

  </div>
</template>
<script>
import { debounce } from '@/utils/util'
import withRouteTracking from '@/utils/withRouteTracking'
const UserProfile = {
  name: 'selectMember',
  props: {

  },
  data () {
    return {
      loading: false,
      finished: false,
      pageNum: 1,
      pageSize: 10,
      load: false,
      isNone: false,
      searchValue: '',
      selectedList: [],
      list: []
    }
  },
  computed: {
    userInfo () {
      return this.$store.getters.userInfo
    },
    createGradeJSON () {
      return JSON.parse(`${sessionStorage.getItem('createGrade')}`)
    },
    groupList () {
      if (!this.createGradeJSON) return []
      return this.createGradeJSON.studentsALLList
    },
    curGroupIndex () {
      return this.$route.query.index
    },
    isGroupLeader () {
      return JSON.parse(this.$route.query.isGroupLeader)
    }
  },
  created () {
    this.list = this.handleResetList(this.groupList).map(item => {
      item.checkedPush = false
      return item
    })
  },
  methods: {

    changeList (val, index) {
      if (this.isGroupLeader) {
        this.list.map(item => {
          item.checkedPush = false
          return item
        })
      }
      this.list[index].checkedPush = !this.list[index].checkedPush
      this.$forceUpdate()
    },

    // 过滤掉组里面的成员
    handleResetList (studentsALLList) {
      if (!studentsALLList) return
      let studentIdsSet = new Set()
      // 遍历groupUsersList并填充studentIdsSet
      if (this.createGradeJSON.groupUsersList && this.createGradeJSON.groupUsersList.length > 0) {
        this.createGradeJSON.groupUsersList.forEach(groupItem => {
          if (groupItem.students && groupItem.students.length > 0) {
            groupItem.students.forEach(item => {
              studentIdsSet.add(item.id)
            })
          }
        })
      }
      // 筛选出不在studentIdsSet中的学生
      let studentsNotInGroups = studentsALLList.filter(student => !studentIdsSet.has(student.id))
      return studentsNotInGroups
    },

    // 组装缓存
    eachStorage () {
      // 获取当前组的学生列表
      const currentGroupStudents = this.createGradeJSON.groupUsersList[this.curGroupIndex].students || []
      // 检查是否存在组长，并且当前操作是否试图添加新的组长
      const existingLeaders = currentGroupStudents.filter(item => item.groupRoleType === 1)
      if (existingLeaders.length > 0 && this.isGroupLeader) {
        this.$toast('已经有一个组长，请删除后添加新的组长！')
        return false
      }

      // 过滤并映射选中的学生到新数组，同时设置他们的角色类型
      const selectedStudents = this.list.filter(item => item.checkedPush).map(item => ({
        ...item,
        groupRoleType: this.isGroupLeader ? 1 : 2
      }))
      // 如果是设置组长，则更新组长的真实姓名
      if (this.isGroupLeader && selectedStudents.length > 0) {
        this.createGradeJSON.groupUsersList[this.curGroupIndex].leaderRealName = selectedStudents[0].realName
      }
      // 更新当前组的学生列表
      this.createGradeJSON.groupUsersList[this.curGroupIndex].students = [
        ...currentGroupStudents,
        ...selectedStudents
      ]
      // 更新缓存
      sessionStorage.setItem('createGrade', JSON.stringify(this.createGradeJSON))
    },

    handleOk () {
      this.eachStorage()
      this.$router.go(-1)
    },

    clearSearchValue () {
      this.searchValue = ''
      this.list = this.handleResetList(this.groupList)
    },

    onCourseSearchEnter: debounce(function () {
      this.list = this.list.filter(item => item.realName.includes(this.searchValue))
    }, 400)
  }
}
export default withRouteTracking(UserProfile)
</script>
<style scoped lang="less">
.my-select {
  width: 100%;
  height: 100vh;
  position: relative;
  display: flex;
  flex-direction: column;
  z-index: 999;
  background-color: #f5f5f5;

  &::before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    z-index: 1;
    width: 100%;
    height: 146px;
    background-image: url("../../../assets/images/grade/student-bg.png");
    background-repeat: no-repeat;
    background-size: 100%;
  }

  .select-div-top {
    position: relative;
  }

  .aifv-div-top {
    position: fixed;
    top: 0;
    left: 0;
    z-index: 9999;
    width: 100%;
    height: 70px;
  }

  .aifv-bg {
    height: 62px;
    width: 100%;
  }

  .head {
    display: flex;
    align-items: center;
    position: absolute;
    padding-top: 12px;
    z-index: 2;
    top: 0;
    left: 10px;
    right: 10px;

    /deep/ .van-search {
      background: transparent;
      width: 100%;
      height: 40px !important;
      padding: 12px 0 16px 0;
      box-sizing: border-box;

      .van-search__content {
        height: 40px !important;
        line-height: 40px !important;
        border-radius: 12px !important;
        border: 1px solid rgba(255, 255, 255, 0.8);
        background: rgba(255, 255, 255, 0.6);
        display: flex;
        align-items: center;
        line-height: 36px !important;
      }

      .van-cell__value {
        line-height: 36px !important;
      }

      .van-field__left-icon {
        margin-top: 6px;
      }
    }
  }

  .list {
    overflow-y: auto;
    height: calc(100vh - 62px - 58px);
    position: relative;
    z-index: 2;
    width: 100%;
    padding: 16px;
    box-sizing: border-box;
    border-top-left-radius: 12px;
    border-top-right-radius: 12px;
    background: linear-gradient(180deg,
        #ffffff 0%,
        #f6f8fa 6%,
        #edf1f4 8%,
        #f2f7fa 100%);

    .list-item {
      display: flex;
      align-items: center;
      background-color: #f9f9f9;
      margin-bottom: 8px;
      padding: 14px 8px 12px;
      border-radius: 12px;

      .icon-check {
        width: 14px;
        height: 14px;
      }

      .avatar {
        width: 42px;
        height: 42px;
        margin-left: 8px;
        margin-right: 6px;
      }

      .info {
        flex: 1;
        overflow: hidden;

        .name {
          font-family: Source Han Sans CN, Source Han Sans CN;
          font-weight: 400;
          font-size: 14px;
          color: #000000;
          line-height: 20px;
          // margin-bottom: 8px;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }

        .currentLevel {
          display: flex;
          align-items: center;
          margin-bottom: 3px;

          .icon-current {
            width: 31px;
            height: 15px;
            margin-right: 2px;
          }

          .level-title {
            font-family: Source Han Sans CN, Source Han Sans CN;
            font-weight: 500;
            font-size: 14px;
            color: #7a8494;
            line-height: 20px;
          }
        }

        .mb8 {
          margin-bottom: 5px;
        }

        .hospital {
          font-family: Source Han Sans CN, Source Han Sans CN;
          font-weight: 500;
          font-size: 14px;
          color: #7a8494;
          line-height: 20px;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
      }
    }
  }

  .empty-block {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    background: linear-gradient(180deg,
        #ffffff 0%,
        #f6f8fa 6%,
        #edf1f4 8%,
        #f2f7fa 100%);
    height: calc(100vh - 62px);
    position: relative;
    top: 0;
    z-index: 2;

    .empty-img {
      width: 185px;
      display: block;
      margin-bottom: 4px;
    }

    .empty-txt {
      font-size: 12px;
      color: #949ba5;
      text-align: center;
    }
  }
}

.confirm-button {
  height: 42px;
  margin: 0 10px;
  width: calc(100% - 20px);
  background-color: #eb1700;
  font-family: Source Han Sans CN, Source Han Sans CN;
  font-weight: 500;
  font-size: 16px;
  color: #ffffff;
  line-height: 42px;
  box-sizing: border-box;
  border: none;
  border-radius: 22px;
  text-align: center;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/views/grade/components/selectGroupList.vue